import * as commonStyles from "utils/commonStyles";
import { theme } from "utils/Theme/theme";

export const errorContainer = {};

export const innerContainer = { ...commonStyles.container, ...commonStyles.flexCenter, flexDirection: "column", mt: 5 };

export const image = { marginTop: theme.spacing(5) };
